export default __webpack_public_path__ + "static/media/BLR-24.40a558fb.JPG";